<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-divider">接种预约</a>
              <small class="bc-divider"> > </small>
              <a class="bc-active">附近医院</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <baidu-map
              class="map"
              :scroll-wheel-zoom="true">
            <bm-view class="map"></bm-view>
            <bm-geolocation
                id="locator"
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :show-address-bar="true"
                :auto-location="true"
                @locationSuccess="locs">
            </bm-geolocation>
            <b-tooltip
                ref="tooltip"
                target="content"
                triggers="hover"
                placement="bottom">
              <strong>先点击右下角按钮进行定位</strong>
            </b-tooltip>
            <bm-local-search
                keyword="医院"
                :auto-viewport="true"
                @infohtmlset="hsc">
            </bm-local-search>
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Nearby",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      assistImg: common.assistImgSrc,
      lastHac: 0,
    }
  },
  methods: {
    hsc(e) {
      const dt = new Date();
      if (dt.getTime() - this.lastHac < 500) {
        const hospital = e.title;
        this.$router.push({path: `/appnew/${hospital}`});
      } else {
        this.lastHac = dt.getTime();
      }
    },
    locs() {
      this.$refs.tooltip.$emit('disable');
    }
  },
  mounted() {
    common.assureLogin(this);
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>
#content {
  background: #f5f5f5;
  overflow: hidden;
  box-shadow: 2px 2px 10px 2px #ddd;
}

.map {
  width: 100%;
  height: 100%;
}
</style>